import React from 'react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * PageLayout — layout padrão das páginas públicas (padronizado com a Home).
 *
 * Encapsula TopBar + Navbar + conteúdo + Footer para garantir consistência
 * visual entre todas as páginas.
 *
 * @typedef {Object} NavLink
 * @property {string} label Rótulo do link.
 * @property {string} to Rota de destino.
 *
 * @typedef {Object} FooterColumn
 * @property {string} title Título da coluna.
 * @property {Array<[string,string]>} links Pares [label, to].
 *
 * @typedef {Object} PageLayoutProps
 * @property {React.ReactNode} children Conteúdo da página.
 * @property {Array<NavLink>} [navLinks] Links do menu principal.
 * @property {Array<FooterColumn>} [footerColumns] Colunas do rodapé.
 */

export default function PageLayout({ children, navLinks = [], footerColumns = [] }) {
  return (
    <div>
      <TopBar />
      <Navbar links={navLinks} />
      {children}
      <Footer columns={footerColumns} />
    </div>
  );
}
